export default __webpack_public_path__ + "media/images/amenities/rice_cooker-aab2c30b5b5a208b04ff7863dae641e4.jpeg";